// extracted by mini-css-extract-plugin
module.exports = {"bold":"ael_wy"};